// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k6eLg{display:flex;flex-direction:column;height:100%;width:100%;background:#fff;z-index:1}.IBzu2{display:flex;justify-content:space-between;align-items:center;gap:8px;height:56px;background:#fcfcfd;padding:0 12px;box-shadow:0px 4px 12px rgba(40,40,99,.06);position:relative;z-index:1}body.capacitor-native .IBzu2{height:calc(56px + var(--capacitor-safe-area-top));padding-top:var(--capacitor-safe-area-top);padding-left:calc(12px + var(--capacitor-safe-area-left));padding-right:calc(12px + var(--capacitor-safe-area-right));box-sizing:border-box}.UcPJ3{flex-shrink:0}.t85FT{height:100%;display:flex;align-items:center;gap:8px;min-width:0}.MhAb0{overflow:hidden}.FVXtC{display:block;flex:1;height:auto;text-align:left;font-size:var(--font-size-h6);line-height:var(--line-height-h6);text-overflow:ellipsis;white-space:nowrap}.FVXtC>*{overflow:hidden;text-overflow:ellipsis}.FVXtC.c950z{font-size:var(--font-size-p1);line-height:var(--line-height-p1)}.OTlsn{flex:1;height:100px;overflow-y:auto}body.capacitor-native .OTlsn{padding-bottom:var(--capacitor-safe-area-bottom);padding-left:var(--capacitor-safe-area-left);padding-right:var(--capacitor-safe-area-right);box-sizing:border-box}.WcqtP{background:#eaeaef}.oKv8R{background:#fcfcfd}.xAHnW{background:#fff}._AHEj{display:flex;align-items:center;justify-content:space-between;background:#f4f4f7;height:54px;padding:0 8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"chartBlue": `#6a9ff0`,
	"chartPeach": `#fbd499`,
	"chartCyan": `#a9e5f2`,
	"chartPink": `#fda5ef`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"root": `k6eLg`,
	"header": `IBzu2`,
	"headerEnd": `UcPJ3`,
	"flexContainer": `t85FT`,
	"headerTitle": `MhAb0`,
	"headerTitleMobile": `FVXtC`,
	"headerTitleMobileH6": `c950z`,
	"content": `OTlsn`,
	"defaultSkin": `WcqtP`,
	"lightSkin": `oKv8R`,
	"whiteSkin": `xAHnW`,
	"footer": `_AHEj`
};
export default ___CSS_LOADER_EXPORT___;
